import React from "react";
import Parser from "application/components/parser";

const DropPoint = (props) => {
  const { display, text } = props;
  return (
    <div className="form__form-wrapper">
      <div className="form__form-body-title" style={{ display: display ? "block" : "none" }}>
        <div className="drop-point-container">
          <Parser text={text} />
        </div>
      </div>
    </div>
  );
};

export default DropPoint;
